import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AppNotification } from "src/app/models/notification";
import { FormComponent, IFormDialogData } from "src/app/shared/form/form.component";
import { DateFormField, NumberFormField, TextFormField } from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";
export interface INotificationDialogData extends IFormDialogData {
    notification: AppNotification;
}

@Component({
  standalone: false,
    selector: 'app-notification-dialog-component',
    templateUrl: './../../shared/form/form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./../../shared/form/form.component.scss'],
})
export class NotificationDialogComponent extends FormComponent<AppNotification> implements OnInit {

    constructor(dialogRef: MatDialogRef<NotificationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: INotificationDialogData,
        protected injector: Injector,
    ) {
        super(dialogRef, null, data, "Notification", injector);
        this.isReadonly = true;
    }
    
    ngOnInit(): void {
        this.isFormLoading = true;
        this.entity = this.data.notification;
        this.initModel();
        this.initFields();
        this.isFormLoading = false;
    }

    getNewObject(): AppNotification {
        return new AppNotification();
    }

    initModel(): void { 
        this.entity.sentDate = new Date(this.entity.notificationSentDate);
        this.entity.sentDate = this.dateFormatService.formatDateTimeToString(this.entity.notificationSentDate as Date, this.dateFormatService.dateToStringFormat); 
        this.isFormLoading = false;
    }

    validate(): boolean {
        return true;
    }

    onBeforeSave(model: AppNotification): void {     
    }

    initFields(): void {       
        this.fields = [
            new DateFormField({ property: nameOf<AppNotification>(x => x.sentDate), name: 'Notification Sent Date', cssClass: "date-assign", readonly: true }),
            new TextFormField({ property: nameOf<AppNotification>(x => x.notificationName), name: 'Notification Name', readonly: true }),
            new TextFormField({ property: nameOf<AppNotification>(x => x.parameterName), name: 'Parameter Name', readonly: true }),
            new NumberFormField({ property: nameOf<AppNotification>(x => x.averagingType), name: 'Averaging Type', readonly: true }),
            new NumberFormField({ property: nameOf<AppNotification>(x => x.value), name: 'Value', readonly: true }),
            new TextFormField({ property: nameOf<AppNotification>(x => x.sensor), name: 'Sensor', readonly: true }),
            new TextFormField({ property: nameOf<AppNotification>(x => x.endPoint), name: 'End Point', readonly: true }),
        ];
    }

}
